import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/Lightbox.css';

const Lightbox = ({ project, onClose, onNext, onPrev, hasNext, hasPrev }) => {
  useEffect(() => {
    // Close on ESC key
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && hasPrev) onPrev();
      if (e.key === 'ArrowRight' && hasNext) onNext();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden'; // Prevent scrolling

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [onClose, onNext, onPrev, hasNext, hasPrev]);

  if (!project) return null;

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="lightbox-close" onClick={onClose} aria-label="Schließen">
          <X size={32} />
        </button>

        {/* Previous Button */}
        {hasPrev && (
          <button className="lightbox-nav lightbox-prev" onClick={onPrev} aria-label="Vorheriges">
            <ChevronLeft size={40} />
          </button>
        )}

        {/* Next Button */}
        {hasNext && (
          <button className="lightbox-nav lightbox-next" onClick={onNext} aria-label="Nächstes">
            <ChevronRight size={40} />
          </button>
        )}

        {/* Media Content */}
        <div className="lightbox-media">
          {project.media_type === 'video' ? (
            <video
              src={project.image_url}
              controls
              autoPlay
              className="lightbox-video"
            />
          ) : (
            <img
              src={project.image_url}
              alt={project.title}
              className="lightbox-image"
            />
          )}
        </div>

        {/* Info */}
        <div className="lightbox-info">
          <h3 className="lightbox-title">{project.title}</h3>
          <p className="lightbox-category">{project.category}</p>
        </div>
      </div>
    </div>
  );
};

export default Lightbox;
